export default __webpack_public_path__ + "assets/export-line-drawing.003ac142.png";